<template>
  <div class="newsHome">
    <div>
      <img src="../../../assets/news/banner.png" alt="" width='100%'/>
    </div>
    <div class="mytabs"  :style="{top : hideHeight ? '0' : '280px'}">
        <div v-for="(item,index) in tabs" :key="item.key" :style="{color:item.isActive ? '#3170FF':'#FFF' , borderBottom:item.isActive ? '2px solid #3170FF' : 'none'}" @click="changeActive(index)">
            {{ item.name }}
        </div>
    </div>
    <div class="article">
        <p>{{activeIndex == 0 ? '小鳗动态' :activeIndex == 1 ? '行业资讯' :'小鳗课堂'  }}</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div v-for="item in listData" :key="item.id" class="detail">
          <div class="detail-title">{{item.title}}</div>
          <img :src="'https://file.smalleel.com/'+item.coverUrl" alt="" srcset="" style="width:240px">
          <div class="detail-content">{{item.firstParagraph}}</div>
          <div class="viewDetail" @click="toDetailother(item.aid,item.type)">查看详情 ></div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      activeIndex:0,
      listData:[],
      work:[],
      tabs:[
          {name:'小鳗动态',key:1,isActive:true},{name:'行业资讯',key:2,isActive:false},{name:'小鳗课堂',key:3,isActive:false}
      ],
      hideHeight:false
    }
  },
  mounted(){
    this.getNew(1)
    window.onscroll=()=>{
      if(document.documentElement.scrollTop == 0 || document.body.scrollTop == 0 ){
          this.hideHeight = false
      }
      if(document.documentElement.scrollTop > 50 || document.body.scrollTop > 50 ){
          this.hideHeight = true
      }
  }
  },
  methods:{
    changeActive(index){
        for (let i = 0; i < this.tabs.length; i++) {
            if(index == i){
                this.tabs[i].isActive = true
            }else{
                this.tabs[i].isActive = false
            }
        }
        this.activeIndex = index
        this.getNew(index+1)
    },
    getNew(type){
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 999);
      params.append('type', type);
      params.append('position', 0);
      this.$axios.post('/api/websiteNews/websiteList',params).then(res=>{
        this.list = res.data.data.records
        let list  = JSON.parse(JSON.stringify(res.data.data.records))
        this.listData = list
      })
    },
    toDetailother (id,type) {
      this.$router.push({
        path: '/phoneNewsDetail/'+ type +'_'+ id + '.html'
      })
    },

    // goPath(id){
    //   this.$router.push("/phoneNewsDetail/"+id+'.html');
    // },
  }
};
</script>

<style scoped lang="scss">
.mytabs{
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    padding-top:19px;
    height: 50px;
    border-radius: 4px;
    width: 100%;
    height: 54px;
    position: fixed;
    left: 0;
    background-color: #24282E;
}
.article{
    margin: 40px 20px 0 20px;
    padding-bottom: 10px;
    padding-top: 60px;
    text-align: left;
    p{
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        padding-bottom: 10px;
        text-align: center;
    }
    .imgCtn{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width:84px;
        height: 3px;
      }
    }
    .detail{
        background-color: #2d2f33;
        margin-top: 20px;
        border-radius: 4px;
        overflow: hidden;
        padding: 26px 20px;
        padding-bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .detail-title{
          font-size: 16px;
          line-height: 18px;
          margin-bottom: 22px;
          padding: 0 20px;
        }
        .detail-content{
          font-size: 12px;
          margin: 16px 0 22px 0;
          padding: 0 20px;
          line-height: 18px;
        }
        img{
          margin: auto;
        }
        .viewDetail{
          text-align: right;
          font-size: 12px;
          color:#3170FF;
          padding:0 0 10px 0;
        }
    }
}
.newsHome{
  background-color:#23262A ;
  color: white;
  min-height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneNews.vue